// extracted by mini-css-extract-plugin
export default {"container":"Loans_container__3Hmul","row":"Loans_row__KqCSo","btn":"Loans_btn__lzlv7"};